module.exports = __webpack_public_path__ + "static/media/unterweisung.acc069e3.jpg";